import React, { useContext } from 'react';
import { BreadcrumbItem } from '../utils/breadcrumbsUtilService';

export type BreadcrumbContextType = {
    breadcrumbArray: BreadcrumbItem[];
    setBreadcrumbArray: (breadcrumbs: BreadcrumbItem[]) => void;
};

export const DEFAULT_CONTEXT: BreadcrumbContextType = {
    breadcrumbArray: [],
    setBreadcrumbArray: (_: BreadcrumbItem[]) => null,
};

export const BreadcrumbContext = React.createContext<BreadcrumbContextType>(DEFAULT_CONTEXT);

export function useBreadcrumbContext() {
    const context = useContext(BreadcrumbContext);
    if (context === null)
        throw new Error(`${useBreadcrumbContext.name} must be used under a BreadcrumbContextProvider`);
    return context;
}

export function useBreadcrumbArray() {
    return useBreadcrumbContext().breadcrumbArray;
}
